import React, { useState } from 'react';
import { Search, Filter, MessageSquare, Building2 } from 'lucide-react';
import { people } from '../../data/mockData';
interface PeopleDirectoryProps {
  tenantId: string;
  onNavigate: (page: string, id?: string) => void;
}
export function PeopleDirectory({
  tenantId,
  onNavigate
}: PeopleDirectoryProps) {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedInterest, setSelectedInterest] = useState<string | null>(null);
  const tenantPeople = people.filter(p => p.tenantId === tenantId);
  // Extract all unique interests
  const allInterests = Array.from(new Set(tenantPeople.flatMap(p => p.interests))).sort();
  const filteredPeople = tenantPeople.filter(p => {
    const matchesSearch = p.firstName.toLowerCase().includes(searchTerm.toLowerCase()) || p.lastName.toLowerCase().includes(searchTerm.toLowerCase()) || p.companyName.toLowerCase().includes(searchTerm.toLowerCase()) || p.role.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesInterest = selectedInterest ? p.interests.includes(selectedInterest) : true;
    return matchesSearch && matchesInterest;
  });
  return <div className="space-y-6" data-id="element-676">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4" data-id="element-677">
        <div className="relative w-full md:w-96" data-id="element-678">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={18} data-id="element-679" />
          <input type="text" placeholder="Personen, Rollen oder Unternehmen suchen..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="w-full pl-10 pr-4 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:border-emerald-500 focus:ring-1 focus:ring-emerald-500 outline-none shadow-sm" data-id="element-680" />
        </div>

        <div className="flex items-center gap-2 overflow-x-auto pb-2 md:pb-0 w-full md:w-auto hide-scrollbar" data-id="element-681">
          <button onClick={() => setSelectedInterest(null)} className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${selectedInterest === null ? 'bg-slate-800 text-white' : 'bg-white border border-slate-200 text-slate-600 hover:bg-slate-50'}`} data-id="element-682">
            Alle Interessen
          </button>
          {allInterests.slice(0, 4).map(interest => <button key={interest} onClick={() => setSelectedInterest(interest)} className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${selectedInterest === interest ? 'bg-slate-800 text-white' : 'bg-white border border-slate-200 text-slate-600 hover:bg-slate-50'}`} data-id="element-683">
              {interest}
            </button>)}
          <button className="px-3 py-2 bg-white border border-slate-200 text-slate-600 rounded-full hover:bg-slate-50 transition-colors flex items-center gap-1" data-id="element-684">
            <Filter size={14} data-id="element-685" />
            <span className="text-sm font-medium" data-id="element-686">Filter</span>
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-id="element-687">
        {filteredPeople.map(person => <div key={person.id} onClick={() => onNavigate('person-profile', person.id)} className="bg-white rounded-xl border border-slate-200 shadow-sm hover:shadow-md transition-all cursor-pointer group flex flex-col" data-id="element-688">
            <div className="p-6 flex flex-col items-center text-center flex-1" data-id="element-689">
              <div className="relative mb-4" data-id="element-690">
                <div className="w-20 h-20 rounded-full bg-slate-100 border-2 border-white shadow-md flex items-center justify-center text-xl font-bold text-slate-600" data-id="element-691">
                  {person.avatar}
                </div>
                {person.isOnline && <div className="absolute bottom-1 right-1 w-4 h-4 bg-green-500 border-2 border-white rounded-full" data-id="element-692"></div>}
              </div>

              <h3 className="text-lg font-bold text-slate-900 group-hover:text-emerald-600 transition-colors" data-id="element-693">
                {person.firstName} {person.lastName}
              </h3>
              <p className="text-sm font-medium text-slate-700 mt-1" data-id="element-694">
                {person.role}
              </p>

              <div className="flex items-center gap-1.5 mt-2 text-sm text-slate-500 hover:text-emerald-600 transition-colors" onClick={e => {
            e.stopPropagation();
            onNavigate('company-profile', person.companyId);
          }} data-id="element-695">
                <Building2 size={14} data-id="element-696" />
                <span className="truncate max-w-[180px]" data-id="element-697">
                  {person.companyName}
                </span>
              </div>

              <div className="flex flex-wrap justify-center gap-1.5 mt-4" data-id="element-698">
                {person.interests.slice(0, 2).map((interest, i) => <span key={i} className="px-2 py-1 bg-slate-50 text-slate-600 text-xs font-medium rounded-md border border-slate-100" data-id="element-699">
                    {interest}
                  </span>)}
              </div>
            </div>

            <div className="px-4 py-3 border-t border-slate-100 bg-slate-50/50 rounded-b-xl flex gap-2" data-id="element-700">
              <button onClick={e => {
            e.stopPropagation();
            onNavigate('messages');
          }} className="flex-1 flex items-center justify-center gap-2 py-2 bg-white border border-slate-200 rounded-lg text-sm font-medium text-slate-700 hover:bg-slate-50 hover:text-emerald-600 transition-colors" data-id="element-701">
                <MessageSquare size={16} data-id="element-702" />
                Nachricht
              </button>
            </div>
          </div>)}
      </div>

      {filteredPeople.length === 0 && <div className="text-center py-12 bg-white rounded-xl border border-slate-200" data-id="element-703">
          <Users size={48} className="mx-auto text-slate-300 mb-4" data-id="element-704" />
          <h3 className="text-lg font-bold text-slate-900 mb-1" data-id="element-705">
            Keine Personen gefunden
          </h3>
          <p className="text-slate-500" data-id="element-706">
            Passen Sie Ihre Suche oder Filter an.
          </p>
        </div>}
    </div>;
}